import { Switch } from '@platform/ui';
import { useModuleStrings } from '@platform/modularity/useModuleStrings';
import type { IControlProps } from '../IControlProps';

/**
 * Так/ні (UIUX/field-types/boolean): у формі — перемикач 42×24 (controls/switch) з доступним підписом поля; у клітинці таблиці
 * (inline) — прапорець 15px. Лише читання — вимкнений перемикач.
 */
export function BooleanSwitch({ id, value, onChange, readOnly, field, rt, size }: IControlProps<boolean>) {
  const strings = useModuleStrings();
  const label = strings.field(rt.key, field.key, field.label);
  if (size === 'inline') {
    return <input id={id} type="checkbox" className="fc-check" checked={Boolean(value)} disabled={readOnly} aria-label={label} onChange={(e) => onChange(e.target.checked)} />;
  }
  return (
    <span id={id} className="fc-switch">
      <Switch checked={Boolean(value)} onChange={(v) => onChange(v)} label={label} disabled={readOnly} />
    </span>
  );
}
